import { render } from "./CelebrationMilestone.vue?vue&type=template&id=6622d80c"
import script from "./CelebrationMilestone.vue?vue&type=script&lang=js"
export * from "./CelebrationMilestone.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__